import initialize_slides_from_dataset from
	'../../../initialize_slides_from_dataset';

class Form {
	constructor(form) {
		const
			transport_selector = form.querySelector('.cccombo.transport'),
			transport_type_header = form.querySelector('h4.transport_type'),
			transport_type_image = form.querySelector('figure.transport_type'),
			transport_photos_slider = form.querySelector('.transport_photos_slider');

		if (transport_selector) {
			const
				transport_selector_button =
					transport_selector.querySelector(':scope > button');

			transport_selector_button.addEventListener('change', () => {
				const selected_transport = transport_selector.querySelector(
					`li[data-value="${transport_selector_button.value}"]:not(.link)`
				);

				if (selected_transport) {
					const
						selected_transport_data = selected_transport.dataset,
						approvedPhotos = selected_transport_data.approvedPhotos;

					transport_type_header.innerText = selected_transport_data.typeTitle;

					if (JSON.parse(approvedPhotos).length > 0) {
						transport_type_image.classList.add('hidden');

						transport_photos_slider.querySelector('.swiper-wrapper')
							.dataset.approvedPhotos = approvedPhotos;

						initialize_slides_from_dataset(transport_photos_slider);

						transport_photos_slider.classList.remove('hidden');

						// This works correctly only when visible
						transport_photos_slider.swiper.update();
					} else {
						transport_photos_slider.classList.add('hidden');

						transport_type_image.querySelector('img').src =
							selected_transport_data.typeImageUrl;

						transport_type_image.classList.remove('hidden');
					}
				}
			});
			transport_selector_button.dispatchEvent(new Event('change'));
		}
	}
}

export { Form };
